import  "../../assets/css/mail-info.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import Panel from "../Panel/Panel";
import SendMailInfoAddress from './SendMailInfoAddress';
import MailButton from "../ProfileButtons/MailButton";
import NonBreakingSpace from "../Expando/NonBreakingSpace";
import SendMailInfoStep from "./SendMailInfoStep";
import appSettings from "../../settings/appSettings";
const { urls } = appSettings;

export function SendMailInfo(props) {
  const { child:childInfo, communityNews } = props.data || {};
  const childID = childInfo?.supportOfficeChildId || "";
  const childName = childInfo?.givenName || "";
  const sendMailStepsData = [
    {
      stepClass: "step1",
      stepNum: 1, 
      title: "Pick the right envelope size", 
      Content() {
        return (
          <p className="deci">
            Letters or small items must fit in a 9x12 inch envelope or smaller.
          </p>
        );
      }
    },
    {
      stepClass: "step2",
      stepNum: 2,
      title: "Front of envelope",
      iconUrl: "https://wvusstatic.com/mywv/msc/envelope_front.svg", 
      alt: "Front of envelope", 
      Content() {
        return (
          <p className="deci">
            Put the mailing address on the front of the envelope.
          </p>
        );
      }
    },
    {
      stepClass: "step3",
      stepNum: 3,
      title: "Back of envelope",
      iconUrl: "https://wvusstatic.com/mywv/msc/envelope_back.svg", 
      alt: "Back of envelope", 
      Content() {
        return (
          <p className="deci">
            Write your name and address on the flap, and the child's first name and child ID # on the bottom of the envelope.
          </p>
        );
      }     
    },
    {
      stepClass: "step4",
      stepNum: 4,
      title: "Top of letter",
      iconUrl: "https://wvusstatic.com/mywv/msc/envelope_open.svg", 
      alt: "Top of letter", 
      Content() {
        return (
          <p className="deci">
            Letters and envelopes can get separated so please write your child's name, ID number and your name at the top of your letter or card.
          </p>
        );
      }     
    },
    {
      stepClass: "step5",
      stepNum: "?",
      stepImage: <img src="https://wvusstatic.com/illustrations/question-mark.svg" width="48" height="48" />,
      title: "What can I put inside an envelope?",
      iconUrl: "https://wvusstatic.com/illustrations/photos-letter.svg", 
      alt: "Inside an envelope", 
      Content() {
        return (
          <p className="deci">
            <ul>
              <li>A letter where you share about your family, friends, and interests.</li>
              <li>Photos of you and your family, and even your pets.</li>
              <li>Small, inexpensive items that fit into a 9"x12" envelope.</li>
            </ul>
          </p>
        );
      } 
    }
  ];

  return (
    <div className="send-mail__wrapper">
      <div className="send-mail__header">
        {/* <img src={childThumb} className="send-mail__photo child-photo--thumbnail" alt="Child's Image" /> */}
        <h3>Send A Letter or Package to <NonBreakingSpace />{childName}</h3>
      </div>

      <div className="send-mail__sidebar">
        <Panel classList="send-mail__child-panel">
          <h3 className="eta">{childName}'s Information</h3>

          <div className="send-mail__child-info-row send-mail__child">
            <FontAwesomeIcon icon={solid("id-badge")} className="send-mail__child-icon" />
            <div className="send-mail__child-info-content">
              <h4 className="eta">Child ID:</h4>
              <div>{childID}</div>
            </div>
          </div>

          <SendMailInfoAddress communityNews={communityNews} />
        </Panel>

        <MailButton ctaUrl={`${urls.core}/sponsor-a-child/support-center/sending-letter-package`} />
      </div>

      <div className="send-mail__steps-container">
        <h3 className="gamma">How to send mail to your sponsored child</h3>
        <ul className="send-mail__steps">
          {sendMailStepsData.map(step => {
            const { Content, ...stepProps} = step;
            return (
              <SendMailInfoStep {...stepProps} key={step.stepNum}>
                <Content />
              </SendMailInfoStep>
            );
          })}
        </ul>
      </div>

    </div>
  );
}

export default SendMailInfo;
